import dayjs from "dayjs";

export const firebaseToJSTime = (time) => (time._seconds + time._nanoseconds * 0.00000001) * 1000;

export const isDaysAfter = (date, numOfDays) => {
  return date && dayjs(date).isAfter(dayjs().add(numOfDays, "day"));
};
